export default __webpack_public_path__ + "static/media/home-finance-service-bg.50b7c644.jpg";